import { render, staticRenderFns } from "./SubscriptionsAdminModal.vue?vue&type=template&id=63528f59&scoped=true&"
import script from "./SubscriptionsAdminModal.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsAdminModal.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionsAdminModal.vue?vue&type=style&index=0&id=63528f59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63528f59",
  null
  
)

export default component.exports